import { ButtonFonts } from 'atoms/Button'
import { SavePrimaryButton } from 'atoms/Button/Templates'
import { TextBoxMaxLine1FontLgBold } from 'atoms/TextBox/Templates'
import { ChildrenWithDividers } from 'containers/ChildrenWithDividers'
import {
  ProfilePreferencesBodySC,
  ProfilePreferencesSC,
} from './ProfilePreferences.styled'

export interface IProfilePreferences {
  title: string
  children: React.ReactNode
  buttonTitle: string
  onButtonClick: () => void
}

export const ProfilePreferences = ({
  title,
  buttonTitle,
  onButtonClick,
  children,
}: IProfilePreferences) => {
  return (
    <ProfilePreferencesSC>
      <TextBoxMaxLine1FontLgBold title={title} />

      <ChildrenWithDividers Container={ProfilePreferencesBodySC}>
        {children}
      </ChildrenWithDividers>

      <SavePrimaryButton
        title={buttonTitle}
        onClick={onButtonClick}
        font={ButtonFonts.FontSmBold}
      />
    </ProfilePreferencesSC>
  )
}
